import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';

@Component({
  selector: 'app-accelators-details',
  templateUrl: './accelators-details.component.html',
  styleUrls: ['./accelators-details.component.css'],
})
export class AccelatorsDetailsComponent implements OnInit {
  private getApi = environment.url + environment.accelaroeGet;
  /**
   * Constructs an instance of the AccelatorsDetailsComponent.
   * @param route - Service to access route parameters.
   * @param router - Service for navigating between routes.
   * @param location - Service to interact with the browser's URL.
   * @param makeapi - Service to make API calls.
   * @param getdata - Service to manage application state.
   */
  constructor(
    private route: ActivatedRoute, // Injects ActivatedRoute to access route parameters
    private router: Router, // Injects Router for navigation
    private location: Location, // Injects Location to interact with browser's URL
    private makeapi: ApiService, // Injects ApiService for API calls
    private getdata: ValueService // Injects ValueService for managing application state
  ) {}
  roleValue;
  /**
   * OnInit lifecycle hook that is called when the component is initialized.
   * It sets the visible source flag to true and retrieves the role value from session storage.
   * It also subscribes to the route query parameters and calls the viewAccelaroeGet function
   * with the decoded id parameter when the _id query parameter is present.
   */
  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
    this.roleValue = sessionStorage.getItem('role');

    // Subscribe to the route query parameters and call the viewAccelaroeGet function
    // with the decoded id parameter when the _id query parameter is present
    this.route.queryParams
      .pipe(filter((params) => params._id))
      .subscribe((params) => {
        this.viewAccelaroeGet(atob(params._id));
      });
  }
  accelaroeView: any = [];
  /**
   * Retrieves the accelerator details from the API and updates the component's data.
   * @param id The ID of the accelerator to retrieve.
   */
  viewAccelaroeGet(id) {
    // Show the loading indicator
    this.getdata.amizhthLoader('show');

    // Make the API request to retrieve the accelerator details
    return this.makeapi
      .method(this.getApi + 'id=' + id, '', 'getunauth')
      .subscribe((data) => {
        // Hide the loading indicator after the API request is complete
        this.getdata.amizhthLoader('hide');
        // Update the component's data with the retrieved accelerator details
        this.accelaroeView = data;
      });
  }
  /**
   * Navigates back to the corporate page.
   *
   * This function navigates back to the corporate page when the back button is clicked.
   */
  backBtn() {
    // Navigate back to the corporate page
    this.router.navigateByUrl('/ncoporate');
  }
  /**
   * Navigates back to the previous page.
   *
   * This function uses the Location service to navigate back to the previous page.
   * It is called when the back button is clicked.
   */
  backBtn2(): void {
    // Navigate back to the previous page
    this.location.back();
  }
}
